import { Loading, useGetIdentity } from 'react-admin';

import { DocumentsPage } from '@sh4res/bo-common/components';

export const DocumentsByCategoryPage = () => {
  const { data: identity, isLoading } = useGetIdentity();

  if (isLoading) {
    return <Loading />;
  }

  const companyIds = identity?.companyId;
  const companyId = Array.isArray(companyIds) ? companyIds[0] : companyIds;

  if (companyId === undefined) {
    return <Loading />;
  }

  return <DocumentsPage companyId={companyId} />;
};
